import { faker } from "@faker-js/faker";
import type { Meta, StoryObj } from "@storybook/react";

import { fakeWeightData } from "@/__mocks__/vitals/weight";
import type { WeightTrackingHistoryProps } from "@/ui/components/vitals/history/WeightTrackingHistory";
import WeightTrackingHistory from "@/ui/components/vitals/history/WeightTrackingHistory";
import { sortObservationsByDate } from "@/utils/vitals/weight.util";

const exampleData = faker.helpers.multiple(() => fakeWeightData(), {
  count: 15,
});

const data = sortObservationsByDate({ data: exampleData, isDescending: false });

const StoryMeta: Meta<WeightTrackingHistoryProps> = {
  title: "Components/Vitals/Weight/History",
  component: WeightTrackingHistory,
  argTypes: {
    data: { control: "object" },
  },
  args: {
    data,
  },
};

type Story = StoryObj<WeightTrackingHistoryProps>;

const Primary: Story = {};

export { Primary };
export default StoryMeta;
